import PropTypes from 'prop-types'
import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Datagrid from 'bstrap-react-mobx-admin/datagrid/datagrid'
import moment from 'moment'
import orderBy from 'lodash/orderBy'
import { DropdownButton, MenuItem, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import HelpOverlay from '../utils/helpOverlay'

const SubmitButton = observer(({ errors, text, onSubmit, ...rest }) => {
  return errors
    ? <Button disabled={errors.size > 0} onClick={onSubmit} {...rest}>{text}</Button>
    : null
})

const EmbeddedEntityInput = ({
  store, state, attr, label, fields, itemsFilterFc, EditForm, items, rowId, edit_title, add_title,
  onAddRow, onDeleteRow, onUpdateRow, customRowStyleClass, selectionChanged, selectionState,
  customListActions, errors, disabled = false, disabledRemove = false, copyModalToggle, extraParam,
  items2add, filter = null, dragbleListEntity, dragbleHelperClass, helper = null, removeCount, addClass,
  addFilter
}) => {
  state = state || store.cv.subentities[attr]
  items = items || store.cv.record.get(attr)
  const sortFields = state._sortField.split(',')
  const sortDirs = state._sortDir.split(',').map((i) => i.toLowerCase())
  const selection = selectionState
  const filterDate = state.attrs && state.attrs.filter(i => linkConst.FILTER_DATE.paramItems.includes(i))
  const filterRegion = state.attrs && state.attrs.filter(i => linkConst.FILTER_REGION.paramItems.includes(i))
  const filterHistory = state.attrs && state.attrs.filter(i => linkConst.HISTORY_FILTER.paramItems.includes(i))
  const items2sort = []

  // film/pricing only - additional data for sorting
  if (items && items2add) {
    items.map(v => {
      const pTier = items2add.find(i => i.id === v.flyprivate_platform_tier_pricing_id)
      items2sort.push(Object.assign({}, v, {
        platform: pTier && pTier.platform,
        type_sale: pTier && pTier.type_sale,
        tier: pTier && pTier.tier
      }))
    })
  }

  // order by fields/dirs
  const sorted = items2sort.length <= 0
    ? orderBy(items, sortFields, sortDirs)
    : orderBy(items2sort || items, sortFields, sortDirs).map(v => items.find(f =>
      ((v.id && f.id === v.id) || (v.control_timestamp && f.control_timestamp === v.control_timestamp))
    ))
  const items2renderTemp = filter ? sorted.filter(filter) : sorted

  // global filters
  const routeBatch = store.router && store.router.currentView &&
    store.router.currentView.rootPath && store.router.currentView.rootPath === '/batch'
  const useFilterDate = filterDate && filterDate.length > 0 && store.dateFilterValue
  const useFilterRegion = filterRegion && filterRegion.length > 0 && store.regionFilterValue
  const useFilterHistory = filterHistory && filterHistory.length > 0 && store.historicDataFilterActive
  const useFilterAdditional = addFilter && addFilter.values && addFilter.key && store.additionalDataFilterActive

  // filters
  const itemsFilter = (i) => {
    const dateF = useFilterDate && filterDate[0] && i[filterDate[0]] && new Date(i[filterDate[0]])
    const dateT = useFilterDate && filterDate[1] && i[filterDate[1]] && new Date(i[filterDate[1]])
    const dateV = useFilterDate && store.dateFilterValue && new Date(store.dateFilterValue)
    const dateResult = useFilterDate && dateV && (
      (!dateF && !dateT) || (dateF && dateT
        ? ((dateV >= dateF) && (dateV <= dateT))
        : (dateF ? (dateV >= dateF) : (dateV <= dateT))
      ))
    const regionF = useFilterRegion && filterRegion[0] && i[filterRegion[0]]
    const regionV = useFilterRegion && store.regionFilterValue
    const regionResult = useFilterRegion && (
      (regionF && (regionF[0] === '-') && regionV !== 'WW' && !(regionF.indexOf(regionV) >= 0)) ||
      (regionF && (regionF[0] !== '-') && (regionF.indexOf(regionV) >= 0))
    )
    // historicaldata
    const historicalDataF = useFilterHistory && filterHistory && i[filterHistory]
    const historicalDataV = useFilterHistory && store.historicDataFilterActive
    const historicalCompare = historicalDataF && historicalDataF.indexOf('T') > 0 ? 'second' : 'day'
    const historicalDataResult = useFilterHistory && (
      !i[filterHistory] ||
      (historicalDataV && !moment(historicalDataF).isBefore(moment(), historicalCompare))
    )
    // additional filter
    const addFilterResult = useFilterAdditional && i[addFilter.key] &&
      !((addFilter.values).includes(i[addFilter.key]))
    // return every possible combination of filters
    const returnLogic = []
    useFilterDate && returnLogic.push(dateResult)
    useFilterRegion && returnLogic.push(regionResult)
    useFilterHistory && returnLogic.push(historicalDataResult)
    useFilterAdditional && returnLogic.push(addFilterResult)
    // final return
    return returnLogic.every(c => c === true)
  }
  // filter data if date exists
  const items2render = (!routeBatch && (useFilterDate || useFilterRegion || useFilterHistory)) || useFilterAdditional
    ? items2renderTemp.filter(itemsFilter)
    : items2renderTemp

  function _createListActions (row) {
    if (disabled) {
      return null
    }

    const lactions = []

    if (store.timeRestriction.checkRow(store, row, state) && store.timeRestriction.checkRow(store, row, state) > 1) {
      lactions.push(
        customListActions
          ? <MenuItem key='view' eventKey='1' onClick={() => store.onSubentityEdit(state, items, row)}>
            <span className='glyphicon glyphicon-eye-open' />&nbsp;{defaultConst.TITLE_VIEW}
          </MenuItem>
          : <span key='view' className='btn btn-default btn-sm' style={{ marginRight: '2px' }}
            onClick={() => store.onSubentityEdit(state, items, row)}>
            <span className='glyphicon glyphicon-eye-open' />&nbsp;{defaultConst.TITLE_VIEW}
          </span>
      )
      customListActions && customListActions(row).forEach((cla, idx) => {
        if (cla.hasOwnProperty('persistant') && cla.persistant === true) {
          lactions.push(
            <MenuItem key={idx} onClick={cla.onClick}>{cla.label}</MenuItem>)
        }
      })
    } else {
      if (customListActions) {
        lactions.push(
          <MenuItem key='edit' eventKey='2' onClick={() => store.onSubentityEdit(state, items, row)}>
            <span className='glyphicon glyphicon-edit' />&nbsp;{defaultConst.TITLE_EDIT}
          </MenuItem>
        )
      } else {
        lactions.push(
          <span key='edit' className='btn btn-info btn-sm' style={{ marginRight: '2px' }}
            onClick={() => store.onSubentityEdit(state, items, row)}>
            <span className='glyphicon glyphicon-edit' />&nbsp;{defaultConst.TITLE_EDIT}
          </span>
        )
      }

      customListActions && customListActions(row).forEach((cla, idx) => {
        lactions.push(
          <MenuItem key={idx} onClick={cla.onClick}>{cla.label}</MenuItem>)
      })
    }

    return lactions
  }

  function listActionDelete (row) {
    if (row === undefined) {
      const itemsFiltred = items && state.attributesFilter
        ? items.filter(i => i[state.attributesFilter.key] === state.attributesFilter.value)
        : 0
      let items1length = items && state.attributesFilter
        ? itemsFiltred.length
        : items && items.length
      if (removeCount) {
        // uploads only
        items1length -= removeCount
      }

      const items2length = items2render && items2render.length
      const itemsD = items1length > 0 && items1length !== items2length
      if (!row) {
        return <div className='sort-buttons-box'>
          <OverlayTrigger
            placement='left'
            overlay={<Tooltip>{
              !state._sortField
                ? 'Sets filters and sorting to the default state'
                : 'Reset filters and sorting to the clean state'
            }</Tooltip>}>
            <Button bsSize='xsmall' bsStyle='default' onClick={() => {
              if (state._sortField === '') {
                state._sortField = state.defaultSort._sortField
                state._sortDir = state.defaultSort._sortDir
              } else {
                state._sortField &&
                  state._sortField.split(',') &&
                  state._sortField.split(',').forEach(f => store.onSubentitySort(state, f, null, items))
                state._sortField = ''
                state._sortDir = ''
              }
            }}>
              <span className='glyphicon glyphicon-ban-circle' />
            </Button></OverlayTrigger>{' '}
          <small>{items1length > 0 && itemsD
            ? <span className={'text-' + (!items2length ? 'danger' : 'success')}>{`[${items2length}/${items1length}x]`}</span>
            : (items1length > 0 ? `[${items1length}x]` : '')
          }</small>
        </div>
      } else {
        return null
      }
    } else {
      if (!disabledRemove) {
        if (store.timeRestriction.checkRow(store, row, state) && store.timeRestriction.checkRow(store, row, state) > 0) {
          return null
        }
        return (
          <span key='del' className='btn btn-danger btn-sm'
            onClick={() => {
              let addMessage = ''
              // message for films/uploads
              if (items && items.length > 0 && row && row.id && row.file_type && Object.prototype.hasOwnProperty.call(row, 'parent_id')) {
                addMessage = items.some(i => row.id === i.parent_id) ? ' All subtitles will be removed too. ' : addMessage
              }
              if (window.confirm('Are you sure to delete this item?' + addMessage)) {
                store.removeSubentity(items, attr, row, onDeleteRow)
              }
            }}>
            <span className='glyphicon glyphicon-remove' />
          </span>
        )
      } else {
        return null
      }
    }
  }

  function listActions (row) {
    if (disabled) {
      return null
    }
    if (row === undefined) {
      return (
        <div style={{ display: 'flex' }} >
          <button type='button' className='btn btn-sm btn-primary'
            onClick={() => {
              store.onSubentityEdit(state, items, null, extraParam)
            }}>
            <em className='glyphicon glyphicon-plus-sign' />&nbsp;{defaultConst.TITLE_ADD}
            {extraParam && Object.prototype.hasOwnProperty.call(extraParam, 'extraTitle') ? ' ' + extraParam.extraTitle : ''}
          </button>
          {
            copyModalToggle && items && items <= 0 ? (
              <HelpOverlay placement={'top'} helpContent={'Copy records from another entity to this one'} >
                <button onClick={copyModalToggle} type='button' className='btn btn-sm btn-primary'>
                  <em className='glyphicon glyphicon-duplicate' />&nbsp; {store.__('Copy')}
                </button>
              </HelpOverlay>
            ) : null
          }
        </div>
      )
    } else if (customListActions) {
      return (
        <DropdownButton bsSize='small' title='actions' id='bg-nested-dropdown'>
          {_createListActions(row)}
        </DropdownButton>
      )
    } else {
      return (
        <div>
          {_createListActions(row)}
        </div>
      )
    }
  }

  const updateFormFieldT = (k, v) => {
    store.cv && store.cv.temporary && store.cv.temporary.set(k, v)
    store._runSubentityValidators(state)
    store._runSubentityGlobalValidator(state, items)
  }
  const errorText = errors && errors.has(attr) ? errors.get(attr) : undefined
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const createdAt = state.record && (state.record.has('created_at')
    ? state.record.get('created_at')
    : state.record.has('createdAt') ? state.record.get('createdAt') : null)
  const updatedAt = state.record && (state.record.has('updated_at')
    ? state.record.get('updated_at')
    : state.record.has('updatedAt') ? state.record.get('updatedAt') : (state.record.has('updated') ? state.record.get('updated') : null))
  const tooltip = (
    (createdAt ? 'Created: ' + moment(createdAt).utc().format(dateFormat).concat(' ') : '') +
    (updatedAt ? 'Updated: ' + moment(updatedAt).utc().format(dateFormat) : '')
  )

  const dialog = state.showForm ? (
    <Modal show backdrop='static' onHide={store.handleSubentityFormClose.bind(store, state)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {state.edited ? edit_title : (add_title || edit_title)}
          <OverlayTrigger placement='left' overlay={tooltip ? <Tooltip>{tooltip}</Tooltip> : <Tooltip>Created/updated: no record</Tooltip>}>
            <span className='header-id'>#{state.record && state.record.has('id') ? state.record.get('id') : <em>new</em>} &nbsp;&nbsp;&nbsp;&nbsp;</span>
          </OverlayTrigger>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          <EditForm
            store={store}
            state={state}
            record={state.record}
            updateFormField={store.updateSubentityField.bind(store, state, items)}
            errors={state.errors}
            temporary={(store.cv && store.cv.temporary) || null}
            updateFormFieldT={updateFormFieldT}
          />
        }
        {state.errors.has('_global')
          ? (Array.isArray(state.errors.get('_global'))
            ? state.errors.get('_global')
            : [state.errors.get('_global')]).map(e => {
            return (Array.isArray(e) ? e : [e]).map((v, k) => (
              <div key={k} className='alert alert-danger'><strong>Error! </strong>{v} </div>
            ))
          })
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>

          {store.timeRestriction.checkSubentity(store, state).stageTwoRestricted ||
            <SubmitButton text={defaultConst.TITLE_SUBMIT} className='btn-primary' errors={state.errors}
              onSubmit={() => store.handleSubentityFormSubmit(state, items, onAddRow, onUpdateRow)} />}

          <button type='button' className='btn btn-default'
            onClick={store.handleSubentityFormClose.bind(store, state)}>{defaultConst.TITLE_CANCEL}</button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null

  let labelR = label ? (
    <h5 htmlFor={attr} className='card-title'>{label} <HelpOverlay store={store} path={helper} /></h5>
  ) : null
  labelR = disabled && labelR ? (
    <div>
      {labelR}
      <span>{store.cv && store.cv.operation && store.cv.operation === linkConst.BATCH_ACTION_CATEGORIES_UPDATE
        ? 'Only one item can be added'
        : 'Requires save before adding item'
      }</span>
    </div>
  ) : labelR

  const noSort = state.noSort && state.noSort.slice ? state.noSort.slice() : state.noSort
  const isSelected = idx => [...selection.get()].indexOf(idx) >= 0
  const onRowSelection = selectionIdx => {
    let selected = [...selection.get()]
    const isSelected = selected.indexOf(selectionIdx) >= 0

    if (selectionIdx.length < 1) {
      selected = []
    } else if (selectionIdx === 'all') {
      selected = items.map((i, idx) => idx)
    } else if (isSelected) {
      selected.splice(selected.indexOf(selectionIdx), 1)
    } else {
      selected.push(selectionIdx)
    }

    selection.set(selected)
    selectionChanged && selectionChanged(selected)
  }

  return (
    <div className={'form-group ' + (addClass || '')}>
      {dialog}
      {labelR}
      {errorText ? <div className='alert alert-danger'>{errorText}</div> : null}
      {typeof store.historicDataFilterEnable !== 'undefined' && store.historicDataFilterEnable(state.attrs) &&
        (<div className='pull-right' style={{ height: '2.1em' }}>{store.historicDataFilter}</div>)
      }
      {typeof store.dateFilterEnable !== 'undefined' && store.dateFilterEnable(state.attrs) &&
        (<div className='pull-right' style={{ height: '2.1em' }}>{store.dateFilter}</div>)
      }
      {typeof store.regionFilterEnable !== 'undefined' && store.regionFilterEnable(state.attrs) &&
        (<div className='pull-right' style={{ height: '2.1em' }}>{store.regionFilter}</div>)
      }

      <Datagrid
        attrs={state.attrs}
        customRowStyleClass={customRowStyleClass}
        dragbleHelperClass={dragbleHelperClass}
        dragbleListEntity={dragbleListEntity}
        fields={fields}
        isSelected={selectionState ? isSelected : undefined}
        listActionDelete={listActionDelete}
        listActions={disabled ? null : listActions}
        noSort={['_delete'].concat(noSort)}
        onRowSelection={selectionState ? onRowSelection : undefined}
        onSort={(sortField, sortDir) => store.onSubentitySort(state, sortField, sortDir, items)}
        rowId={rowId}
        sortstate={state}
        state={{ items: items2render, loading: false }}
        titles={state.titles}
      />
    </div>
  )
}
EmbeddedEntityInput.propTypes = {
  fields: PropTypes.array.isRequired,
  EditForm: PropTypes.func.isRequired,
  attr: PropTypes.string.isRequired,
  items: PropTypes.object,
  rowId: PropTypes.func.isRequired,
  onAddRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onUpdateRow: PropTypes.func,
  label: PropTypes.string,
  initVals: PropTypes.func,
  edit_title: PropTypes.string,
  add_title: PropTypes.string,
  customListActions: PropTypes.func,
  store: PropTypes.object.isRequired,
  dragbleHelperClass: PropTypes.string,
  addClass: PropTypes.string
  // validateForm: PropTypes.func,
  // onFieldUpdated: PropTypes.func,
}
export default observer(EmbeddedEntityInput)
